<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

/**
 * Starter component
 */
export default {
  page: {
    title: "Starter Page",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Starter Page",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ]
    };
  }
};
</script>
<template>
  <Layout>
    <div>
    <section class="my-5 pt-5">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <div class="home-wrapper">
              <div class="mb-5">
                <img src="@/assets/images/logo-dark.png" alt="logo" height="24" />
              </div>

              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="maintenance-img">
                    <img src="@/assets/images/maintenance.png" alt class="img-fluid mx-auto d-block" />
                  </div>
                </div>
              </div>
              <h3 class="mt-5">La page est en cours de construction</h3>
              <p>Revenez nous voir prochainement.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  </Layout>
</template>